import { IEvent } from "~app/common/services/cqs/event.service";
export abstract class BasicEvent implements IEvent {
    $type: string;
    constructor($type: string) {
        this.$type = $type;
    }
}
